import { useState } from 'react';
import PropTypes from 'prop-types';
// mui
import { List, FormControl, MenuItem, Select, Stack, Typography, InputBase, styled } from '@mui/material';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "src/@/components/ui/accordion";
import { Checkbox } from "src/@/components/ui/checkbox";
import { Button } from 'src/@/components/ui/button';
import Iconify from 'src/components/Iconify';
import useAuth from 'src/hooks/useAuth';
import { useDispatch } from 'src/redux/store';
import { removeChatFromList, updateChatList } from 'src/redux/slices/chat';
import getActionAceitarChat from 'src/actions/chats/getActionAceitarChat';
import getActionChatByChatId from 'src/actions/chats/getActionChatByChatId';
import ChatAtendimentoItem from '../ChatsListItem/ChatAtendimentoItem';

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': { marginTop: theme.spacing(1.5) },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 10,
    padding: '4px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  },
}));

const CompactInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    fontSize: 12,
    padding: '4px 8px',
    color: '#374151',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      borderColor: '#9ca3af',
    },
    '&:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 1px #3b82f6',
    },
    '&::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
  },
}));

ChatConversationListPendente.propTypes = {
  chats: PropTypes.array.isRequired,
  isOpenSidebar: PropTypes.bool,
  listaTagsReduce: PropTypes.array,
  listaCanaisReduce: PropTypes.array,
  tagsSelecionadas: PropTypes.array,
  canaisSelecionados: PropTypes.array,
  changeTags: PropTypes.func,
  changeCanais: PropTypes.func,
  chatsNaoLidos: PropTypes.array,
  changeChatsNaoLidos: PropTypes.func,
  isFiltered: PropTypes.bool,
  limparFiltro: PropTypes.func,
};

export default function ChatConversationListPendente({
  chats,
  isOpenSidebar,
  listaTagsReduce = [],
  listaCanaisReduce = [],
  tagsSelecionadas = [],
  canaisSelecionados = [],
  changeTags = () => {},
  changeCanais = () => {},
  chatsNaoLidos = [],
  changeChatsNaoLidos = () => {},
  isFiltered = false,
  limparFiltro,
  ...other
}) {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  // FILTRO: Só mostra chats conforme filtros selecionados
  const chatsFiltrados = chats.filter(chat => {
    const tagsDoChat = (chat.tags_ids || []).map(tagObj => tagObj.nome);
    const matchTag =
      tagsSelecionadas.length === 0 ||
      tagsSelecionadas.some(tag => tagsDoChat.includes(tag));

    // Filtro por canal
    const matchCanal =
      canaisSelecionados.length === 0 ||
      canaisSelecionados.includes(chat.nome_canal);

    // Filtro por lido/não lido (supports both pt-BR and en labels)
    const unreadLabels = ["Chats não lidos", "Unread chats"];
    const readLabels = ["Chats lidos", "Read chats"];
    const matchChat =
      chatsNaoLidos.length === 0 ||
      chatsNaoLidos.some(filtro =>
        unreadLabels.includes(filtro)
          ? chat.novaMensagem === "sim"
          : readLabels.includes(filtro)
            ? chat.novaMensagem !== "sim"
            : true
      );

    return matchTag && matchCanal && matchChat;
  });

  const handleAceitar = async (chat) => {
    const { _id } = chat;
    setLoading(true);
    try {
      const res_chat = await getActionChatByChatId({ chatId: _id });
      if (res_chat.data.statusRoom !== 'Atendendo') {
        dispatch(removeChatFromList({ chatId: _id, status: 'Pendente' }));
        getActionAceitarChat({ chatId: _id, usuarioId: user.id });
        let dataToUpdade = {
          _id: chat._id,
          scope: {
            novaMensagem: 'sim',
            statusRoom: 'Atendendo',
            direciona_usuarios: [user.id],
            direciona_setores: [],
            lastUpdate: new Date()
          }
        };
        dispatch(updateChatList(dataToUpdade));
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>
      <List disablePadding {...other}>
        {chatsFiltrados.map((chat) => (
          <ChatAtendimentoItem
            key={chat._id}
            chat={chat}
            loading={loading}
            isOpenSidebar={isOpenSidebar}
            onSelectConversation={() => { }}
            onAceitarChat={() => handleAceitar(chat)}
          />
        ))}
      </List>
    </>
  );
}